import { render, staticRenderFns } from "./RewardsCard.vue?vue&type=template&id=452c26f4"
import script from "./RewardsCard.vue?vue&type=script&lang=js"
export * from "./RewardsCard.vue?vue&type=script&lang=js"
import style0 from "./RewardsCard.vue?vue&type=style&index=0&id=452c26f4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports